// Desktop hover dropdown menu with debounce delay + Touch support
document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('.header__inline-menu > ul > li');
  const OPEN_DELAY = 150; // Open delay in ms
  const CLOSE_DELAY = 300; // Close delay in ms

  menuItems.forEach(item => {
    const details = item.querySelector('details');
    if (!details) return;

    let openTimer = null;
    let closeTimer = null;

    // Clear all timers
    const clearTimers = () => {
      if (openTimer) {
        clearTimeout(openTimer);
        openTimer = null;
      }
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };

    // Open menu
    const openMenu = () => {
      clearTimers();
      details.setAttribute('open', '');
    };

    // Close menu
    const closeMenu = () => {
      clearTimers();
      details.removeAttribute('open');
    };

    // Desktop: hover events (only on non-touch devices or larger screens)
    if (window.innerWidth >= 990 && !('ontouchstart' in window)) {
      // Open menu on mouse enter (with delay)
      item.addEventListener('mouseenter', () => {
        clearTimers();
        openTimer = setTimeout(openMenu, OPEN_DELAY);
      });

      // Close menu on mouse leave (with delay)
      item.addEventListener('mouseleave', () => {
        clearTimers();
        closeTimer = setTimeout(closeMenu, CLOSE_DELAY);
      });
    }

    // Touch support for tablets and touch-enabled devices
    const summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (e) => {
        // On touch devices, prevent default and toggle manually
        if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
          e.preventDefault();

          // Close other open menus first
          menuItems.forEach(otherItem => {
            const otherDetails = otherItem.querySelector('details');
            if (otherDetails && otherDetails !== details && otherDetails.hasAttribute('open')) {
              otherDetails.removeAttribute('open');
            }
          });

          // Toggle current menu
          if (details.hasAttribute('open')) {
            closeMenu();
          } else {
            openMenu();
          }
        }
      });
    }

    // Handle submenus (nested dropdowns)
    const subDetails = details.querySelectorAll('details');
    subDetails.forEach(subDetail => {
      const parentLi = subDetail.closest('li');
      const subSummary = subDetail.querySelector('summary');

      if (parentLi) {
        let subOpenTimer = null;
        let subCloseTimer = null;

        const clearSubTimers = () => {
          if (subOpenTimer) {
            clearTimeout(subOpenTimer);
            subOpenTimer = null;
          }
          if (subCloseTimer) {
            clearTimeout(subCloseTimer);
            subCloseTimer = null;
          }
        };

        // Desktop hover for submenus
        if (window.innerWidth >= 990 && !('ontouchstart' in window)) {
          parentLi.addEventListener('mouseenter', () => {
            clearSubTimers();
            subOpenTimer = setTimeout(() => {
              subDetail.setAttribute('open', '');
            }, OPEN_DELAY);
          });

          parentLi.addEventListener('mouseleave', () => {
            clearSubTimers();
            subCloseTimer = setTimeout(() => {
              subDetail.removeAttribute('open');
            }, CLOSE_DELAY);
          });
        }

        // Touch support for submenus
        if (subSummary) {
          subSummary.addEventListener('click', (e) => {
            if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
              e.preventDefault();

              // Close other submenus at same level
              parentLi.parentElement.querySelectorAll(':scope > li > details[open]').forEach(openDetails => {
                if (openDetails !== subDetail) {
                  openDetails.removeAttribute('open');
                }
              });

              // Toggle current submenu
              if (subDetail.hasAttribute('open')) {
                subDetail.removeAttribute('open');
              } else {
                subDetail.setAttribute('open', '');
              }
            }
          });
        }
      }
    });
  });

  // Close all menus when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.header__inline-menu')) {
      menuItems.forEach(item => {
        const details = item.querySelector('details');
        if (details && details.hasAttribute('open')) {
          details.removeAttribute('open');
        }
      });
    }
  });
});